import React from 'react';

import { FolderOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import styled from 'styled-components';

interface BoardCardProps {
  title: string;
  description?: string;
  onClick?: () => void;
}

const StyledCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .ant-card-body {
    padding: 16px;
  }
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: #e6f4ff;
  margin-bottom: 12px;
`

const StyledIcon = styled(FolderOutlined)`
  font-size: 24px;
  color: var(--color-primary);
`

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`

const Description = styled.p`
  margin: 4px 0 0;
  font-size: 14px;
  color: #8c8c8c;
`

export const BoardCard: React.FC<BoardCardProps> = ({
  title,
  description,
  onClick,
}) => {
  return (
    <StyledCard onClick={onClick}>
      <IconWrapper>
        <StyledIcon />
      </IconWrapper>

      <Title>
        {title}
      </Title>

      {description && (
        <Description>
          {description}
        </Description>
      )}
    </StyledCard>
  )
}